import { render, staticRenderFns } from "./StipendiatSborContacts.vue?vue&type=template&id=7467d178&scoped=true&"
import script from "./StipendiatSborContacts.vue?vue&type=script&lang=js&"
export * from "./StipendiatSborContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7467d178",
  null
  
)

export default component.exports